import React from 'react';
import { Link } from 'react-router-dom';
import { ModalBox, Skeleton, useModalContext } from '@fourthwall/components';
import * as S from './TilesModal.styled';
const getComponent = ({ to, href }) => {
    if (to) {
        return Link;
    }
    if (href) {
        return 'a';
    }
    return 'button';
};
const ITEM_DEFAULT_WIDTH = 288;
export const TilesModal = ({ children, isLoading, heading, itemsCount = 3, ...props }) => {
    const { close } = useModalContext();
    return (React.createElement(ModalBox, { maxWidth: itemsCount * ITEM_DEFAULT_WIDTH, onClose: close, title: heading, ...props }, isLoading ? (React.createElement(TilesModalSkeleton, { itemsCount: itemsCount })) : (React.createElement(S.Container, null, children))));
};
const TilesModalItem = ({ to, href, image, imageAlt, heading, subheading, onClick, children, }) => {
    const { close } = useModalContext();
    return (React.createElement(S.Item, { as: getComponent({ to, href }), to: to, onClick: onClick || close },
        React.createElement(S.ItemImageContainer, null,
            React.createElement(S.Image, { alt: imageAlt, src: image })),
        React.createElement(S.Content, null,
            React.createElement(S.Heading, { type: "h7", weight: "semibold" }, heading),
            subheading && React.createElement(S.Subheading, null, subheading),
            children)));
};
const TilesModalFooter = ({ children }) => {
    return React.createElement("div", null, children);
};
const TilesModalItems = ({ children }) => {
    return React.createElement(S.Items, null, children);
};
const TilesModalSkeleton = ({ itemsCount }) => (React.createElement(S.Container, null,
    React.createElement(S.Items, null, Array.from({ length: itemsCount }, (_, index) => (React.createElement(S.SkeletonItem, { key: `skeleton-${index}` },
        React.createElement(S.ItemImageContainer, null,
            React.createElement(Skeleton.Shape, { width: "100%", height: "100%" })),
        React.createElement(S.Content, null,
            React.createElement(Skeleton, { gap: 8 },
                React.createElement(Skeleton.Shape, { width: "80%", height: 18 }),
                React.createElement(Skeleton.Shape, { width: "60%", height: 14 })))))))));
TilesModal.Item = TilesModalItem;
TilesModal.Items = TilesModalItems;
TilesModal.Footer = TilesModalFooter;
